const EcoFriendlyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        fill="#15DBCD"
        fillRule="evenodd"
        d="M29.815 8.532C27.672 5.683 23.638 1 20.273 1s-7.4 4.683-9.543 7.532a1.961 1.961 0 00-.094.138c2.825.64 6.212 1.705 9.637 3.482 3.426-1.777 6.812-2.841 9.637-3.482a1.96 1.96 0 00-.095-.138zM17.156 13.977C9.799 10.673 3 10.673 3 10.673v11.054c0 3.118.826 6.043 2.271 8.568a31.97 31.97 0 011.522-4.039c1.68-3.686 4.634-8.324 9.7-11.832a33 33 0 01.663-.447zM7.583 33.445c.01-.064 1.663-10.355 10.617-16.554a31.178 31.178 0 012.073-1.317c.696.405 1.389.843 2.074 1.317 8.91 6.168 10.591 16.39 10.617 16.553A17.226 17.226 0 0120.274 39c-5.018 0-9.535-2.139-12.691-5.555z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#3365FF"
        fillRule="evenodd"
        d="M37.545 21.727V10.673s-10.363 0-19.345 6.218S7.583 33.446 7.583 33.446A17.227 17.227 0 0020.273 39c9.54 0 17.272-7.733 17.272-17.273z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default EcoFriendlyIcon;
